<header id="header-main">
  <a id="header-brand" aria-label="NBC Sports Event Pro">
    <span class="logo-nbc-sports" (click)="onBrandClick()"></span>
  </a>
  <div id="header-search">
    <input type="text" placeholder="Search..." />
    <button>
      <i class="fa fa-search"></i>
    </button>
  </div>
  <div id="header-profile" *ngIf="user">
    <div style="padding-bottom: 3px">
      <span href="#" id="header-user">
        <i class="fa fa-user"></i>
        <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
      </span>
      |
      <a class="btn-link"
        data-toggle="modal"
        style="cursor: pointer"
        (click)="openOlympicsHelpModel('Talent')"
      >
        Help
      </a>
      |
      <a (click)="logout()"> Log Out </a>
    </div>
    <div>
      <span style="font-size: 11px; padding-left: 25px">
        Last Login - {{ user.lastLogin }}
      </span>
    </div>
  </div>
</header>
<global-announcement></global-announcement>

<div id="body" class="event-theme">
  <div class="col-main">
    <router-outlet></router-outlet>
  </div>
</div>
